import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FilterOption} from '../../../core/models/filter-option';
import {TextKeys} from '../../../core/i18n/text-keys';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {TableColumn} from '../../../core/models/table-column';

@Component({
  selector: 'app-filter-options-selection',
  templateUrl: './filter-selection-list.component.html',
  styleUrls: ['./filter-selection-list.component.scss'],
})
export class FilterSelectionListComponent implements OnInit {
  @Input() filterOptions: any;
  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter<any>();

  texts = TextKeys;

  oneSelected$: Observable<boolean>;

  list: FilterOption[] = [];
  list$ = new BehaviorSubject<FilterOption[]>([]);

  private newStructure: boolean;

  constructor() {
  }

  ngOnInit() {
    Object.keys(this.filterOptions).forEach((e) => {
      const filterOption = this.filterOptions[e] as any;

      this.newStructure = 'text' in filterOption;
      const addItem = !('text' in filterOption) ||
        (!(filterOption as TableColumn)?.noFilterOption &&
        !(filterOption as TableColumn)?.disabled);

      if (addItem) {
        this.list.push({
          name: 'text' in filterOption ? filterOption.text : filterOption.name,
          selected: filterOption?.selected,
          id: e,
        } as FilterOption);
      }
    });

    // set all to true if none is selected
    // the reason is that if no is selected the FilterAll
    // property is true for requests to the backend.
    if (!this.list.find((item) => item.selected == true)) {
      this.list.forEach((item) => (item.selected = true));
    }

    this.list$.next(this.list);
    this.oneSelected$ = this.list$.pipe(
      map((list) => !!list.find((rows) => rows.selected == true))
    );
  }

  onToggleAll() {
    this.oneSelected$
      .subscribe((value) => {
        if (value) {
          this.list.forEach((row) => (row.selected = false));
        } else {
          this.list.forEach((row) => (row.selected = true));
        }
      })
      .unsubscribe();
    this.list$.next(this.list);
  }

  handleOnCancel() {
    this.onCancel.emit();
  }

  onSelection(i: number) {
    this.list[i].selected = !this.list[i].selected;
    this.list$.next(this.list);
  }

  handleOnSave() {
    // when all are selected save none.
    if (!this.newStructure) {
      if (!this.list.find((item) => item.selected == false)) {
        this.list.forEach((item) => (item.selected = false));
      }
    } else {
      const selectedFilter = this.list.find((f: any) => f.selected);
      if (!selectedFilter) {
        this.list.forEach(item => item.selected = true);
      }
    }

    const newSelection = JSON.parse(JSON.stringify(this.filterOptions));

    Object.keys(newSelection).forEach((e) => {
      // this.list.push(this.filterOptions[e] as FilterOption);
      const newSetting = this.list.find((item) => item.id == e);
      if (newSetting) {
        newSelection[e].selected = newSetting.selected;
      }
    });

    this.onSave.emit(newSelection);
  }
}
